import AppShell, { type AppShellProps } from '@/components/AppShell'
import RegistrationForm from '@/components/RegistrationForm'
import RegistrationPageLayout from '@/components/RegistrationPageLayout'
import type { CustomFieldDef, EventTheme, RegistrationField, TitleOption } from '@/lib/registrationFormShared'

export interface RegisterProps extends Omit<AppShellProps, 'children'> {
  event: EventTheme
  registrationFields: RegistrationField[]
  customFields: CustomFieldDef[]
  userTypes: string[]
  bloodTypes: string[]
  genderOptions: string[]
  countries: string[]
  titleFieldType?: 'text' | 'select'
  titleOptions?: TitleOption[]
  positionFieldType?: 'text' | 'select'
  positionOptions?: string[]
  lockedUserType?: string | null
  registrationLinkSlug?: string | null
  errors: Record<string, string>
  currentLocale: string
  locales: string[]
  urls: AppShellProps['urls'] & { submit: string }
  translations: AppShellProps['translations'] & {
    title: string
    firstName: string
    lastName: string
    phoneNumber: string
    email: string
    organization: string
    position: string
    badgeType: string
    gender: string
    country: string
    city: string
    age: string
    idNumber: string
    passportNumber: string
    bloodType: string
    image: string
    pleaseSelect: string
    otherTitle?: string
    register: string
    saveChanges?: string
    registrationClosed: string
    requiredFields: string
    privacyPolicy: string
    privacyPolicyAgreement: string
  }
}

export default function Register(props: RegisterProps) {
  const {
    event, registrationFields, customFields, userTypes, bloodTypes,
    genderOptions, countries, titleFieldType, titleOptions, positionFieldType, positionOptions, lockedUserType, registrationLinkSlug, errors, currentLocale, locales, urls, translations: t, ...shell
  } = props

  return (
    <RegistrationPageLayout event={event} currentLocale={currentLocale} locales={locales} urls={urls} translations={t} pageVariant="form" registrationLinkSlug={registrationLinkSlug} {...shell}>
      <RegistrationForm
        event={event}
        registrationFields={registrationFields}
        customFields={customFields}
        userTypes={userTypes}
        bloodTypes={bloodTypes}
        genderOptions={genderOptions}
        countries={countries}
        titleFieldType={titleFieldType}
        titleOptions={titleOptions}
        positionFieldType={positionFieldType}
        positionOptions={positionOptions}
        lockedUserType={lockedUserType}
        registrationLinkSlug={registrationLinkSlug}
        errors={errors}
        currentLocale={currentLocale}
        translations={{ ...t, saveChanges: t.saveChanges ?? t.register }}
        submitUrl={urls.submit}
        submitMethod="post"
        mode="create"
      />
    </RegistrationPageLayout>
  )
}
